import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    background: 'white',
    borderBottomRightRadius: '10px',
    overflowY: 'hidden'
  },

  container: {
    borderRadius: '0.5rem',
    height: 'calc(100% - 2.25rem)',
    position: 'relative',
    overflow: 'hidden',

    '& > :last-child': {
      paddingBottom: '1rem',
      borderBottom: 'none',
      flexWrap: 'wrap'
    }
  },

  label: {
    position: 'absolute',
    borderRadius: '0.25rem',
    padding: '0.125rem 0.5rem',
    backgroundColor: 'white',
    top: '0',
    left: '1rem',
    transform: 'translateY(-50%)'
  },

  content: {
    margin: '0.5rem',
    width: 'calc(100% - 1rem)',
    height: 'calc(100% - 1rem)',
    overflowY: 'auto'
  },

  section: {
    display: 'flex',
    borderBottom: '1px solid rgba(230, 234, 236, 0.9)',
    boxSizing: 'border-box',

    '& > :first-child': {
      margin: '0 5%',
      width: '90%',
      padding: '1rem 0',
      overflow: 'hidden'
    }
  }
}))

export default useStyles
